export default __webpack_public_path__ + "static/media/img-0093-china-full-face.56d0c51e.png";